export default function prettyFloat( num ) {

  return num.toString().indexOf('.') !== -1 ? parseFloat( num ).toFixed( 2 ) : num;

}